
import { Modal } from "../ui/Modal";
import { DriverForm } from "../ui/DriverForm";
import { useToast } from "../ui/Toast";

export function AddDriverModal({ isOpen, onClose }) {
  const { showSuccess } = useToast();

  const handleSuccess = () => {
    showSuccess('Driver added successfully!');
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Driver"
      size="xl"
      closeOnBackdropClick={false}
    >
      <div className="p-4 sm:p-6">
        <DriverForm
          context="admin"
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          showHeader={false}
        />
      </div>
    </Modal>
  );
}
